var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.625L2 2.625L12 2.625L12 3.625L14 3.625L14 2.125C14 1.2985 13.216 0.625001 12.25 0.625001L1.75 0.625C0.784001 0.625 2.03389e-07 1.2985 1.31134e-07 2.125L0 3.625L2 3.625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87612 15.2005L7.87612 6.625L6.12388 6.625L6.12388 15.2005L3.23883 12.2546L2 13.5196L7 18.625L12 13.5196L10.7612 12.2546L7.87612 15.2005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.f909b88d0434657b161dbaa94f0c59f3.svg";
export { ForwardRef as ReactComponent };